import { Box, Grid, TextField, Typography, useTheme } from "@mui/material";
import coverImage from "../../../../media/images/headCover.svg";
import SearchIcon from "../../../../media/images/icons/search";
import UserRegIcon from "../../../../media/images/icons/userRegister";
import UserLoginIcon from "../../../../media/images/icons/login-newsvg";
import UserProfileIcon from "../../../../media/images/icons/user-profile";
import BigCarIcon from "../../../../media/images/icons/bigCar";
import { Link } from "react-router-dom";
import CourseCard from "./CourseCard";

export default function CourseMain() {
  const theme = useTheme();

  const courses = [
    {
      path: "#",
      title: "آموزش ثبت‌نام",
      icon: <UserRegIcon color={theme.palette.secondary.dark} />,
    },
    {
      path: "#",
      title: "آموزش ورود",
      icon: <UserLoginIcon color={theme.palette.secondary.dark} />,
    },
    {
      path: "#",
      title: " ایجادبار",
      icon: <UserProfileIcon color={theme.palette.secondary.dark} />,
    },
    {
      path: "#",
      title: "آموزش‌ دریافت‌بار",
      icon: <BigCarIcon color={theme.palette.secondary.dark} />,
    },
  ];

  return (
    <>
      <Box
        sx={{
          backgroundImage: `
          linear-gradient(0deg, rgba(211, 134, 39, 0.97) 46.43%, rgba(239, 183, 114, 0.81) 135.27%),
            url(${coverImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
          borderRadius: "20px",
          justifyContent: "end",
          paddingX: "16px",
          boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
        }}
      >
        <Typography
          sx={{
            marginTop: "60px",
            fontSize: "22px",
            fontWeight: "900",
            color: "background.default",
          }}
        >
          آموزش ویدئویی{" "}
        </Typography>
        <Typography
          sx={{
            marginBottom: "16px",
            color: "background.default",
          }}
        >
          راهنما و آموزش ویدئویی خدمات و سرویس های بازارگاه{" "}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid gray",
          paddingX: "8px",
          borderRadius: "8px",
        }}
      >
        <TextField
          placeholder="سوال یا موضوع را جست‌وجو کنید "
          size="small"
          sx={{
            flex: 1,
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none !important",
              outline: "none !important",
            },
            "& .MuiInputBase-input": {
              border: "none !important",
              outline: "none !important",
            },
            "& .MuiInputBase-root": {
              border: "none !important",
              outline: "none !important",
            },
            border: "none",
          }}
        />
        <SearchIcon color={theme.palette.primary.main} />
      </Box>

      <Typography
        sx={{
          textAlign: "center",
          fontWeight: 600,
        }}
      >
        دسته‌بندی ویدئوهای آموزشی:{" "}
      </Typography>

      <Box
        sx={{
          display: "flex",
          // alignItems: "center",
          gap: "16px",
        }}
      >
        {courses.map((item) => (
          <Link
            to={item.path}
            style={{
              borderStyle: "solid",
              borderWidth: "1px",
              borderColor: theme.palette.secondary.dark,
              boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
              display: "flex",
              flexDirection: "column",
              flex: 1,
              padding: "8px 8px 8px 8px",

              borderRadius: "16px",
              justifyContent: "center",
              alignItems: "center",

              gap: "10px",

              backgroundColor: theme.palette.background.default,
            }}
          >
            {item.icon}
            <Typography
              sx={{
                textAlign: "center",
                color: "secondary.dark",
              }}
            >
              {item.title}
            </Typography>
          </Link>
        ))}
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
        }}
      >
        <Link
          to={""}
          style={{
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: theme.palette.secondary.dark,
            boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
            display: "flex",
            flexDirection: "column",
            flex: 1,
            padding: "8px 8px 8px 8px",

            borderRadius: "16px",
            justifyContent: "center",
            alignItems: "center",

            gap: "10px",

            backgroundColor: theme.palette.background.default,
          }}
        >
          <UserProfileIcon color={theme.palette.secondary.dark} />
          <Typography
            sx={{
              textAlign: "center",
              color: "secondary.dark",
            }}
          >
            آموزش‌های صاحبان کالا
          </Typography>
        </Link>
        <Link
          to={""}
          style={{
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: theme.palette.secondary.dark,
            boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
            display: "flex",
            flexDirection: "column",
            flex: 1,
            padding: "8px 8px 8px 8px",

            borderRadius: "16px",
            justifyContent: "center",
            alignItems: "center",

            gap: "10px",

            backgroundColor: theme.palette.background.default,
          }}
        >
          <BigCarIcon color={theme.palette.secondary.dark} />
          <Typography
            sx={{
              textAlign: "center",
              color: "secondary.dark",
            }}
          >
            آموزش‌های رانندگان
          </Typography>
        </Link>
      </Box>

      <Box
        sx={{
          marginTop: "10px",
        }}
      >
        <Grid container xs={12}>
          <CourseCard />
          <CourseCard />
          <CourseCard />
          <CourseCard />
        </Grid>
      </Box>
    </>
  );
}
